import { ShippingAddress } from "../../orders/utils/types";

type FieldGroup = {
  side: "left" | "right";
  fields: (keyof ShippingAddress)[];
};

export const fieldGroups: FieldGroup[] = [
  {
    side: "left",
    fields: [
      "name",
      "companyName",
      "addressLine1",
      "addressLine2",
      "addressLine3",
    ],
  },
  {
    side: "right",
    fields: [
      "city",
      "county",
      "district",
      "stateOrRegion",
      "municipality",
      "postalCode",
      "countryCode",
      "phone",
    ],
  },
];
